import * as types from './mutation-types'
import { webService } from '../api'
import { apiActions } from '../api'

const actions = {
    initToggle({ commit, dispatch, state }, apiAction) {
        commit(types.SET_API_TOGGLE_INIT, { apiAction });
    },
    setUrlParams({ commit, dispatch, state }, urlParams) {
        commit(types.SET_URL_PARAMS, { urlParams });
    },
}
// 将api中定义的apiActions制作成action
for (let i in apiActions) {
    let obj = {
        [i]: function ({ commit, dispatch, state }, { params = {}, options = {} } = {}) {
            let apiAction = i;
            return webService({ commit, dispatch, apiAction }, { params, apiOptions: options }).then((data) => {
                // console.log(data);
                return data;
            }).catch((reason) => {
                throw reason;
            })
        },
    }
    Object.assign(actions, obj);
}
export default actions


// WEBPACK FOOTER //
// ./src/store/actions.js